// packages/shared-hooks/src/lead-tasks/useMyDay.ts
//
// `GET /lead-tasks/my-day?tz=...` — returns the four bucket arrays plus
// per-bucket counts. The backend resolves `now` against the supplied
// IANA timezone and groups rows in that wall clock; the UI echoes
// `response.timezone` so labels render against the same anchor.
import { useQuery } from '@tanstack/react-query';
import { MY_DAY_DEFAULT_TIMEZONE, MyDayResponseSchema, type MyDayResponse } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadTasksKeys } from './keys.js';

export interface UseMyDayOptions {
  tz?: string;
  /** Disable while the auth bootstrap is still hydrating. */
  enabled?: boolean;
}

export function useMyDay(options: UseMyDayOptions = {}) {
  const client = useApiClient();
  const tz = options.tz ?? MY_DAY_DEFAULT_TIMEZONE;
  return useQuery<MyDayResponse>({
    queryKey: leadTasksKeys.myDay(tz),
    enabled: options.enabled ?? true,
    queryFn: ({ signal }) =>
      client.get<MyDayResponse>(
        '/lead-tasks/my-day',
        { signal, query: { tz } },
        MyDayResponseSchema,
      ),
  });
}
